import { Injectable } from "@angular/core";
import { PaymentRepositoryService } from "../services/payment-repository.service";
import { DwAction, DwActionHandler, DwActionResult, DwActionState, DwActionType, DwGridActionResult, DwMdFormActionState, DwMdFormInitActionHandler, DwMdFormInitActionState, DwMessageSeverity, DwModalButtonStandardConfigs, DwModalConfig, DwModalResult, DwModalService, DwModalSize } from "@devwareapps/devware-cap";
import { AppMetaDataItemNames, CheckRidePaymentEntity, PaymentReferenceStatusAllItems } from "../../../meta-data/app-meta-data.service";
import { Observable, of } from "rxjs";
import { map, mergeMap } from "rxjs/operators";
import { CheckrideRefundPaymentRequest } from "../models/checkride-refund-payment-request.model";
import { AddCardModalComponent } from "../components/add-card-modal/add-card-modal.component";
import { AddPaymentMethodActionConfigComponent } from "./add-payment-method/config/add-payment-method-action-config/add-payment-method-action-config.component";
import { AddPaymentMethodConfig } from "./add-payment-method/model/add-payment-method-config.model";
import { PaymentMethodUtilService } from "../services/payment-method-util.service";


@DwAction({
    keyName: 'add-payment-method',
    display: 'Add payment Method',
    actionType: DwActionType.gridAction,
    isGlobal: false,
    parentItemName: AppMetaDataItemNames.PaymentCard,
    allowOnce: true,
    configComponent: AddPaymentMethodActionConfigComponent,
    defaultButtonConfig: {
        buttonClass: 'btn btn-success mr-1 mt-1',
        buttonText: 'Add Card',
        iconClass: 'fa fa-credit-card'
    },
})
@Injectable()
export class AddPaymentMethodActionService implements DwActionHandler<AddPaymentMethodConfig> {

    constructor(private paymentRepositoryService: PaymentRepositoryService,
        private paymentMethodUtilService: PaymentMethodUtilService
    ) { }

    handleAction(actionState: DwMdFormActionState): Observable<DwGridActionResult> {
        const checkridePayment: CheckRidePaymentEntity = actionState.data;
        return this.paymentMethodUtilService.showAddCardModal(actionState.actionConfig)
         .pipe(map((modalResult: DwModalResult) => {
                const result = new DwGridActionResult();

                result.success = !modalResult.cancelled;
                result.refreshData = !modalResult.cancelled;

                return result;
            }));
    }

    // private showModal(addPaymentMethodConfig: AddPaymentMethodConfig): Observable<DwGridActionResult> {
    //     let modalConfig = new DwModalConfig();

    //     modalConfig.title = "Add Card";
    //     modalConfig.component = AddCardModalComponent;
    //     modalConfig.buttons = DwModalButtonStandardConfigs.instance.SaveAndClose;

    //     modalConfig.buttons[0].buttonText = "Add Card";
    //     modalConfig.preventClose = false;
    //     modalConfig.data = addPaymentMethodConfig;

    //     // modalConfig.modalSize = DwModalSize.custom;
    //     // modalConfig.customModalWidth = '600px';
    //     // modalConfig.customModalHeight = '800px';

    //     modalConfig.modalSize = DwModalSize.responsive;

    //     return this.dwModalService.showModal(modalConfig)
    //         .pipe(map((modalResult: DwModalResult) => {
    //             const result = new DwGridActionResult();

    //             result.success = !modalResult.cancelled;
    //             result.refreshData = !modalResult.cancelled;

    //             return result;
    //         }));
    // }
}

